import React from 'react'
import { GridColumn as Column, Grid, GridCellProps } from '@progress/kendo-react-grid'

import { CountryOverridesDtoResponse } from '../../../../api/Trading-Accounts/Types/CountryOverridesType'
import { FilterCell } from '../../../../components/Filter/FilterCell'
import MoreButton from '../../../../components/MoreButton/MoreButton'

interface CountryOverridesTableProps {
  data: CountryOverridesDtoResponse[]
  onToggleTradingAllowed: (
    countryId: string,
    platformTypeId: number,
    tickmillCompanyId: number,
    newValue: boolean
  ) => void
  onDeleteCountryOverride: (
    countryId: string,
    platformTypeId: number,
    tickmillCompanyId: number,
    tradingAllowed: boolean
  ) => void
}

export const CountryOverridesTable: React.FC<CountryOverridesTableProps> = ({
  data,
  onToggleTradingAllowed,
  onDeleteCountryOverride,
}) => {
  return (
    <Grid
      data={[...data].sort((a, b) => a.country.name.localeCompare(b.country.name))}
      total={data.length}
      resizable
    >
      <Column field='country.name' title='Country' />

      <Column
        title='Trading Allowed'
        cell={(props: GridCellProps) => {
          const { country, platformType, tickmillCompany, tradingAllowed } = props.dataItem

          const [loading, setLoading] = React.useState(false)

          const handleChange = async () => {
            try {
              setLoading(true)
              await onToggleTradingAllowed(
                country.id,
                platformType.id,
                tickmillCompany.id,
                !tradingAllowed
              )
            } catch (err) {
              console.error('Failed to update tradingAllowed:', err)
            } finally {
              setLoading(false)
            }
          }

          return (
            <td style={{ textAlign: 'center' }}>
              <input
                type='checkbox'
                checked={tradingAllowed}
                onChange={handleChange}
                disabled={loading}
              />
              {loading && <span style={{ marginLeft: 4 }}>⏳</span>}
            </td>
          )
        }}
      />

      <Column
        width={50}
        title=''
        filterCell={FilterCell}
        cell={(gridCellProps: GridCellProps) => {
          const { country, platformType, tickmillCompany, tradingAllowed } = gridCellProps.dataItem

          return (
            <td>
              <MoreButton
                items={[
                  {
                    name: 'Delete',
                    onClick: () =>
                      onDeleteCountryOverride(
                        country.id,
                        platformType.id,
                        tickmillCompany.id,
                        tradingAllowed
                      ),
                  },
                ]}
                data-test='more-button'
              />
            </td>
          )
        }}
      />
    </Grid>
  )
}
